import { ISignInProcessInitWithUrlDto } from "@presentation/controllersModels/ISignInProcessInitWithUrlDto";
import { signInProcessIdParam, signInProcessSecretParam } from "@presentation/params/signInProcess";
import { useRef, useState } from "react";
import styles from "./LoginManager.module.css";
import LoginWithPasswordSlide from "./LoginWithPasswordSlide";
import { Lumni } from "../Components/Icons/Lumni";
import Button from "../Components/Button";
import LoginWithEmailOtpSlide from "./LoginWithEmailOtpSlide";
import classNames from "classnames";
import ConfirmationSlide from "./ConfirmationCode/ConfirmationSlide";

const LoginManager = () => {

  const signInProcessIdInputRef = useRef<HTMLInputElement>(null);
  const signInProcessSecretInputRef = useRef<HTMLInputElement>(null);
  const signInProcessFormRef = useRef<HTMLFormElement>(null);
  const signInProcessSubmitRef = useRef<HTMLButtonElement>(null);

  const [loginType, setLoginType] = useState<boolean>(true);
  const [sliderPosition, setSliderPosition] = useState<boolean>(false);
  const [pendingConfirmation, setPendingConfirmation] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const onSuccess = (sessionInfo: ISignInProcessInitWithUrlDto) => {
    if (
      !signInProcessIdInputRef.current
      || !signInProcessSecretInputRef.current
      || !signInProcessFormRef.current
      || !signInProcessSubmitRef.current
    ) {
      return alert("Error inesperado");
    }

    signInProcessIdInputRef.current.value = sessionInfo.signInProcessId;
    signInProcessSecretInputRef.current.value = sessionInfo.secret;
    signInProcessFormRef.current.action = sessionInfo.initSignInUrl;
    signInProcessSubmitRef.current.click();
  };

  return (
    <section className={styles.root}>
      <Lumni className={styles.lumni} />
      {
        pendingConfirmation
          ?
          <ConfirmationSlide email={email} password={password} onSuccess={onSuccess} />
          :
          <div className={styles.content}>
            <div className={styles.header}>
              <h1>Bienvenido a nuestro portal</h1>
              <p className={styles.message}>
                {
                  loginType || (!loginType && !sliderPosition)
                    ? "Por favor, ingresa el correo electrónico que utilizaste en tu proceso de postulación."
                    : "Por favor, ingresa el código enviado a tu correo electrónico y a tu WhatsApp. Revisa también en spam, promociones o correos no deseados."
                }
              </p>
            </div>
            <LoginWithPasswordSlide setEmail={setEmail} setPassword={setPassword} setPendingConfirmation={setPendingConfirmation} className={classNames({ [styles.hidden]: !loginType })} onSuccess={onSuccess} />
            <LoginWithEmailOtpSlide className={classNames({ [styles.hidden]: loginType })} sliderPosition={sliderPosition} setSliderPosition={setSliderPosition} onSuccess={onSuccess} />
            <div className={styles.footer}>
              <h2 className={styles.otpCode}><span>O inicia sesión con</span></h2>
              <Button onClick={() => [setLoginType(!loginType), setSliderPosition(false)]} variant="secondary" className={styles.button}>
                {
                  loginType
                    ? "Código a mi correo y WhatsApp"
                    : "Contraseña"
                }
              </Button>
            </div>
          </div>
      }
      <form ref={signInProcessFormRef} style={{ width: 0, height: 0 }} method="get">
        <input ref={signInProcessIdInputRef} hidden name={signInProcessIdParam}></input>
        <input ref={signInProcessSecretInputRef} hidden name={signInProcessSecretParam}></input>
        <button ref={signInProcessSubmitRef} hidden type="submit"></button>
      </form>
    </section>
  )
};

export default LoginManager;
